import React, { useEffect } from "react";
import { loadStyles } from "../../../utils/cssLoader";

/**
 * Flexible auto-fill CSS Grid wrapper.
 * Uses `grid-template-columns: repeat(auto-fill, minmax(columns px, 1fr))`
 * so it adapts to any container width.
 */
const Grid = ({
  columns = 300,
  gap = 16,
  className = "",
  children,
  loadCSS = true,
}) => {
  useEffect(() => {
    if (loadCSS === true || loadCSS === "true") {
      loadStyles("interactivesGrid");
    }
  }, [loadCSS]);

  return (
    <div
      className={`interactives-grid ${className}`.trim()}
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${columns}px, 1fr))`,
        gap: `${gap}px`,
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
